/* I&C redesign: seasonal hero motion (canvas), bottle and name pairing, sale countdown. */
(() => {
  const hero = document.querySelector(".rd .hero--season");
  if (!hero) return;
  const season = hero.dataset.seasonHero;

  /* ---------- Bottles and their names light up together ---------- */
  const bottles = [...hero.querySelectorAll(".scene__bottle")];
  const names = [...hero.querySelectorAll(".scene__list a")];
  bottles.forEach((b, i) => {
    const pair = [b, names[i]].filter(Boolean);
    const set = (on) => () => pair.forEach((el) => el.classList.toggle("is-lit", on));
    pair.forEach((el) => {
      el.addEventListener("mouseenter", set(true)); el.addEventListener("mouseleave", set(false));
      el.addEventListener("focus", set(true)); el.addEventListener("blur", set(false));
    });
  });

  /* ---------- Live sale countdown: "starts in" before the sale, "ends in" during it, ticking every second ---------- */
  const clock = hero.querySelector("[data-sale-clock]");
  if (clock) {
    const start = new Date(clock.dataset.start).getTime(), end = new Date(clock.dataset.end).getTime();
    const label = clock.querySelector("[data-clock-label]");
    const unit = (k) => clock.querySelector(`[data-clock-${k}]`);
    const cells = { d: unit("d"), h: unit("h"), m: unit("m"), s: unit("s") };
    const texts = [...document.querySelectorAll("[data-clock-text]")];          // the copies in the gold band
    const two = (n) => String(n).padStart(2, "0");
    let phase = "";
    const tick = () => {
      const now = Date.now();
      const next = now < start ? "before" : now <= end ? "during" : "over";
      const t = Math.max(0, Math.floor(((next === "before" ? start : end) - now) / 1000));
      const v = { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
      if (next !== phase) {
        phase = next;
        label.textContent = phase === "before" ? clock.dataset.before : phase === "during" ? "Sale ends in" : "This offer has ended";
        clock.classList.toggle("is-over", phase === "over");
      }
      Object.keys(cells).forEach((k) => { if (cells[k]) cells[k].textContent = two(v[k]); });
      const line = phase === "over" ? "Offer ended" : `${phase === "before" ? "Starts in" : "Ends in"} ${v.d}d ${two(v.h)}h ${two(v.m)}m ${two(v.s)}s`;
      texts.forEach((el) => { el.textContent = line; });
      return phase !== "over";
    };
    if (tick()) {
      const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000);
    }
  }

  /* ---------- Backdrop: slow motion drawn on two canvases (behind and in front of the scene) ---------- */
  const canvases = [hero.querySelector(".season-canvas--back"), hero.querySelector(".season-canvas--front")];
  const ctxs = canvases.map((c) => c.getContext("2d"));
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const rand = (a, b) => a + Math.random() * (b - a);
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
  let W = 0, H = 0;
  // where the photo sits in the hero: the wide one covers it (anchored 70% 100%), the tall one is pinned to the top on phones
  const PHOTO = 2688 / 1520;
  const photo = hero.querySelector(".season-photo");
  let zoom = 1;                                          // the CSS push-in on the photo, read every frame
  const box = () => {
    if (W <= 900) return { l: 0, t: 0, w: W, h: W * PHOTO };
    const h = Math.max(H, W / PHOTO), w = h * PHOTO;
    return { l: (W - w) * 0.7, t: H - h, w, h };
  };
  const at = (fx, fy) => {                               // a point in the photo (fractions) → hero pixels
    const b = box();
    const x = b.l + fx * b.w, y = b.t + fy * b.h;
    if (zoom === 1) return { x, y };
    const ox = W * 0.7, oy = H * 0.86;                   // matches transform-origin on .season-photo
    return { x: ox + (x - ox) * zoom, y: oy + (y - oy) * zoom };
  };
  const unit = () => box().w * zoom;                     // one photo-width in pixels
  const photoH = () => box().h;
  const photoTop = () => box().t;
  // where the sea meets the sky in the summer photo
  const horizon = () => photoTop() + photoH() * (W <= 900 ? 0.354 : 0.465);

  /* falling things: petals, leaves, snow */
  const drift = (layer, count, make, colors) => {
    let parts = [];
    const spawn = (anywhere) => {
      const front = layer === 1;
      const z = front ? rand(1.6, 2.4) : rand(0.35, 1);
      const p = { z, color: pick(colors), phase: rand(0, 6.3), r: rand(0, 6.3) };
      if (make === "petal") Object.assign(p, { s: rand(7, 12) * z, vx: rand(0.12, 0.3) * z, vy: rand(0.16, 0.34) * z, vr: rand(-0.01, 0.01), flip: rand(0, 6), vf: rand(0.01, 0.025) });
      if (make === "leaf") Object.assign(p, { s: rand(9, 15) * z, vx: rand(-0.08, 0.12) * z, vy: rand(0.22, 0.45) * z, vr: rand(-0.012, 0.012), flip: rand(0, 6), vf: rand(0.008, 0.02) });
      if (make === "snow") Object.assign(p, { s: rand(0.8, 2.2) * z * (front ? 3 : 1), vx: rand(-0.05, 0.05), vy: rand(0.18, 0.5) * z });
      if (make === "dust") Object.assign(p, { s: rand(0.6, 1.6) * z * (front ? 2.5 : 1), vx: rand(-0.06, 0.06), vy: rand(0.04, 0.14) * z, tw: rand(0.6, 1.6) });
      p.x = anywhere ? rand(0, W) : (make === "petal" ? rand(-0.3 * W, 0.7 * W) : rand(-0.2 * W, W));
      p.y = anywhere ? rand(0, H) : rand(-60, -10);
      return p;
    };
    return {
      layer,
      init() { const n = layer === 1 ? count : Math.round(count * Math.max(0.5, (W * H) / (1440 * 900))); parts = Array.from({ length: n }, () => spawn(true)); },
      tick(ctx, t, dt) {
        const front = layer === 1;
        parts.forEach((p, i) => {
          if (dt) {
            const sway = Math.sin(t * 0.7 + p.phase) * (make === "leaf" ? 0.6 : 0.25);
            p.x += (p.vx + sway * 0.4) * dt; p.y += p.vy * dt;
            if (p.vr) p.r += p.vr * dt;
            if (p.vf) p.flip += p.vf * dt;
            if (p.y > H + 40 || p.x > W + 60 || p.x < -0.4 * W) parts[i] = p = spawn(false);
          }
          const alpha = front ? 0.35 : 0.35 + 0.55 * p.z;
          ctx.save(); ctx.translate(p.x, p.y);
          if (make === "petal") {
            ctx.rotate(p.r); ctx.scale(1, 0.35 + 0.65 * Math.abs(Math.sin(p.flip)));
            const g = ctx.createRadialGradient(0, 0, 0, 0, 0, p.s);
            g.addColorStop(0, p.color); g.addColorStop(front ? 0.25 : 0.7, p.color); g.addColorStop(1, "rgba(255,255,255,0)");
            ctx.globalAlpha = alpha; ctx.fillStyle = g;
            ctx.beginPath(); ctx.ellipse(0, 0, p.s, p.s * 0.62, 0, 0, Math.PI * 2); ctx.fill();
          } else if (make === "leaf") {
            ctx.rotate(p.r); ctx.scale(0.4 + 0.6 * Math.abs(Math.sin(p.flip)), 1);
            ctx.globalAlpha = front ? 0.22 : alpha * 0.85; ctx.fillStyle = p.color;
            ctx.beginPath(); ctx.moveTo(0, -p.s);
            ctx.quadraticCurveTo(p.s * 0.75, -p.s * 0.2, 0, p.s); ctx.quadraticCurveTo(-p.s * 0.75, -p.s * 0.2, 0, -p.s); ctx.fill();
            ctx.globalAlpha *= 0.5; ctx.strokeStyle = "rgba(40,20,10,0.6)"; ctx.lineWidth = 0.8;
            ctx.beginPath(); ctx.moveTo(0, -p.s * 0.9); ctx.lineTo(0, p.s * 1.15); ctx.stroke();
          } else if (make === "dust") {                         // gold dust catching the light
            const a = 0.35 + 0.45 * Math.abs(Math.sin(t * p.tw + p.phase));
            const g = ctx.createRadialGradient(0, 0, 0, 0, 0, p.s * 2.4);
            g.addColorStop(0, "rgba(255,230,180,1)"); g.addColorStop(0.35, "rgba(240,200,130,0.7)"); g.addColorStop(1, "rgba(240,200,130,0)");
            ctx.globalAlpha = (front ? 0.3 : 0.75) * a; ctx.fillStyle = g;
            ctx.beginPath(); ctx.arc(0, 0, p.s * 2.4, 0, Math.PI * 2); ctx.fill();
          } else {
            const g = ctx.createRadialGradient(0, 0, 0, 0, 0, p.s * 2);
            g.addColorStop(0, "rgba(255,255,255,1)"); g.addColorStop(front ? 0.15 : 0.45, "rgba(255,255,255,0.8)"); g.addColorStop(1, "rgba(255,255,255,0)");
            ctx.globalAlpha = front ? 0.28 : alpha * 0.8; ctx.fillStyle = g;
            ctx.beginPath(); ctx.arc(0, 0, p.s * 2, 0, Math.PI * 2); ctx.fill();
          }
          ctx.restore();
        });
      },
    };
  };

  /* ---------- Halloween: everything is placed by where it sits in the photo ---------- */
  // x of width, y of height, r of width. lights: [x, y, glow radius, flicker seed, strength, flicker depth];
  // a reflection on the wet stone shares the seed of the light above it, so they flicker together.
  const HALLOWEEN = {
    wide: {
      moon: [0.77, 0.114, 0.044],
      web: [0.934, 0.19, 0.2],                              // where the spider hangs from, and how far it drops
      mist: [0.32, 1, 0.655, 0.745],
      eyes: [[0.3, 0.42], [0.42, 0.34], [0.2, 0.37], [0.5, 0.46]],     // in the dark trees above the headline
      lights: [
        [0.958, 0.733, 0.113, 0, 1, 1], [0.978, 0.681, 0.041, 0, 0.85, 1], [0.937, 0.68, 0.033, 0, 0.78, 1], [0.949, 0.84, 0.068, 0, 0.57, 1],
        [0.867, 0.344, 0.05, 3, 0.92, 0.7], [0.87, 0.837, 0.05, 3, 0.37, 0.7],
        [0.659, 0.656, 0.041, 5, 0.67, 1], [0.761, 0.684, 0.028, 6, 0.63, 1], [0.594, 0.718, 0.035, 7, 0.68, 1], [0.632, 0.712, 0.024, 8, 0.59, 1],
        [0.789, 0.689, 0.024, 9, 0.58, 1], [0.713, 0.607, 0.019, 10, 0.53, 1], [0.681, 0.578, 0.017, 13, 0.51, 1], [0.73, 0.631, 0.017, 15, 0.49, 1],
        [0.912, 0.689, 0.024, 18, 0.48, 1], [0.69, 0.543, 0.015, 19, 0.46, 1],
        [0.713, 0.357, 0.028, 12, 0.53, 0.6], [0.677, 0.35, 0.024, 14, 0.52, 0.6], [0.651, 0.298, 0.017, 16, 0.48, 0.6],
        [0.601, 0.346, 0.035, 17, 0.52, 0.6], [0.671, 0.25, 0.015, 20, 0.44, 0.6],
      ],
    },
    tall: {
      moon: [0.648, 0.08, 0.105],
      web: [0.2, 0.125, 0.26],
      mist: [0, 1, 0.385, 0.43],
      eyes: [[0.04, 0.3], [0.95, 0.28], [0.3, 0.335]],
      lights: [
        [0.949, 0.889, 0.15, 0, 0.5, 1], [0.978, 0.868, 0.055, 0, 0.45, 1], [0.916, 0.862, 0.051, 0, 0.4, 1],   // behind the copy: kept gentle
        [0.947, 0.946, 0.028, 0, 0.29, 1], [0.966, 0.954, 0.028, 0, 0.28, 1], [0.943, 0.969, 0.016, 0, 0.27, 1], [0.963, 0.932, 0.02, 0, 0.26, 1],
        [0.241, 0.405, 0.087, 2, 0.79, 1], [0.231, 0.39, 0.032, 2, 0.56, 1], [0.263, 0.391, 0.024, 2, 0.52, 1],
        [0.315, 0.416, 0.051, 4, 0.63, 1], [0.09, 0.404, 0.047, 6, 0.6, 1], [0.131, 0.415, 0.032, 7, 0.54, 1], [0.375, 0.419, 0.032, 8, 0.54, 1],
        [0.77, 0.431, 0.044, 9, 0.59, 1], [0.446, 0.414, 0.036, 10, 0.54, 1], [0.668, 0.435, 0.032, 11, 0.53, 1], [0.883, 0.438, 0.036, 12, 0.52, 1],
        [0.18, 0.412, 0.036, 15, 0.59, 1], [0.562, 0.426, 0.032, 16, 0.54, 1], [0.726, 0.44, 0.028, 17, 0.49, 1], [0.428, 0.423, 0.024, 24, 0.45, 1],
        [0.547, 0.424, 0.02, 25, 0.45, 1], [0.828, 0.444, 0.02, 26, 0.45, 1],
        [0.62, 0.249, 0.028, 14, 0.51, 0.6], [0.661, 0.21, 0.028, 19, 0.46, 0.6], [0.718, 0.205, 0.024, 21, 0.45, 0.6],
        [0.67, 0.247, 0.02, 22, 0.45, 0.6], [0.747, 0.27, 0.02, 23, 0.45, 0.6],
      ],
    },
  };
  const spot = () => HALLOWEEN[W <= 900 ? "tall" : "wide"];
  const TAU = Math.PI * 2;
  const glow = (ctx, x, y, r, stops) => {
    const g = ctx.createRadialGradient(x, y, 0, x, y, r);
    stops.forEach(([o, c]) => g.addColorStop(o, c));
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, TAU); ctx.fill();
  };

  /* candle flames in the jack-o'-lanterns, candles, lantern and castle windows: brighten and dim around the photo */
  const flames = () => {
    const flick = (t, s) => 0.55 * Math.sin(t * 7.3 + s * 1.7) + 0.3 * Math.sin(t * 12.7 + s * 3.1) + 0.15 * Math.sin(t * 23.9 + s * 5.3);
    return {
      layer: 0,
      init() {},
      tick(ctx, t) {
        const u = unit();
        spot().lights.forEach(([fx, fy, fr, seed, k, depth]) => {
          const { x, y } = at(fx, fy), r = fr * u;
          const f = flick(t, seed) * depth * (0.8 + 0.2 * Math.sin(t * 0.6 + seed));  // −1 … 1
          if (f > 0) {
            ctx.globalCompositeOperation = "lighter";
            glow(ctx, x, y, r, [[0, `rgba(255,178,90,${0.46 * k * f})`], [0.35, `rgba(255,128,40,${0.22 * k * f})`], [1, "rgba(255,110,30,0)"]]);
          } else {
            ctx.globalCompositeOperation = "source-over";
            glow(ctx, x, y, r * 0.8, [[0, `rgba(10,4,0,${0.42 * k * -f})`], [1, "rgba(10,4,0,0)"]]);
          }
        });
        ctx.globalCompositeOperation = "source-over";
      },
    };
  };

  /* the moon: a breathing halo, and dark clouds drifting across it */
  const moon = (count) => {
    let clouds = [];
    const make = (u) => ({ u, speed: 1 / rand(38, 60), dy: rand(-0.7, 0.8), sx: rand(2.2, 3.4), sy: rand(0.32, 0.55), a: rand(0.5, 0.75) });
    return {
      layer: 0,
      init() { clouds = Array.from({ length: count }, (_, i) => make((i + rand(0, 0.6)) / count)); },
      tick(ctx, t, dt) {
        const [mx, my, mr] = spot().moon, c = at(mx, my), R = mr * unit();
        ctx.globalCompositeOperation = "lighter";
        const a = 0.07 + 0.04 * Math.sin(t * 0.45);
        glow(ctx, c.x, c.y, R * 3.4, [[0.25, `rgba(205,215,240,${a})`], [1, "rgba(205,215,240,0)"]]);
        ctx.globalCompositeOperation = "source-over";
        clouds.forEach((p, i) => {
          if (dt) { p.u += (p.speed * dt) / 60; if (p.u > 1) clouds[i] = p = make(0); }
          const fade = Math.sin(p.u * Math.PI);                        // thin out at both ends of the pass
          ctx.save(); ctx.translate(c.x + (p.u * 2 - 1) * R * 5, c.y + p.dy * R); ctx.scale(p.sx, p.sy);
          glow(ctx, 0, 0, R, [[0, `rgba(14,18,34,${p.a * fade})`], [0.55, `rgba(22,28,48,${p.a * fade * 0.55})`], [1, "rgba(22,28,48,0)"]]);
          ctx.restore();
        });
      },
    };
  };

  /* bats that circle the moon, and now and then one swoops right past */
  const drawBat = (ctx, x, y, s, dir, f) => {
    const wy = f * s * 0.55;
    ctx.save(); ctx.translate(x, y); ctx.scale(dir, 1);
    ctx.beginPath(); ctx.ellipse(0, 0, s * 0.16, s * 0.3, 0, 0, TAU); ctx.fill();
    ctx.beginPath(); ctx.moveTo(-s * 0.08, -s * 0.26); ctx.lineTo(-s * 0.12, -s * 0.44); ctx.lineTo(0, -s * 0.3); ctx.lineTo(s * 0.12, -s * 0.44); ctx.lineTo(s * 0.08, -s * 0.26); ctx.fill();
    [-1, 1].forEach((k) => {
      ctx.beginPath(); ctx.moveTo(0, -s * 0.1);
      ctx.quadraticCurveTo(k * s * 0.5, -s * 0.38 + wy * 0.5, k * s * 1.1, -s * 0.16 + wy);
      ctx.quadraticCurveTo(k * s * 0.95, s * 0.04 + wy * 0.6, k * s * 0.78, s * 0.08 + wy * 0.5);
      ctx.quadraticCurveTo(k * s * 0.64, -s * 0.02 + wy * 0.4, k * s * 0.5, s * 0.14 + wy * 0.3);
      ctx.quadraticCurveTo(k * s * 0.32, s * 0.02 + wy * 0.2, 0, s * 0.12);
      ctx.fill();
    });
    ctx.restore();
  };
  const bats = (count) => {
    let parts = [], swoop = null, wait = 0;
    const sky = () => {                                          // the band of sky around the moon
      const [mx, my, mr] = spot().moon, c = at(mx, my), R = mr * unit(), wide = W > 900;
      const x0 = Math.max(W * (wide ? 0.45 : 0.05), c.x - R * (wide ? 6 : 3));
      return { x0, y0: Math.max(wide ? 80 : 64, c.y - R * 1.4), h: R * (wide ? 4.5 : 2.6) };
    };
    const spawn = (anywhere) => {
      const m = sky(), dir = Math.random() < 0.5 ? 1 : -1;
      return {
        dir, s: rand(5, 9), v: rand(0.5, 0.9), flap: rand(10, 14), phase: rand(0, 6.3), amp: rand(8, 22),
        x: anywhere ? rand(m.x0, W) : (dir > 0 ? m.x0 - 20 : W + 20),
        fy: rand(0, 1),
      };
    };
    return {
      layer: 0,
      init() { parts = Array.from({ length: count }, () => spawn(true)); swoop = null; wait = rand(4, 8) * 60; },
      tick(ctx, t, dt) {
        const m = sky();
        ctx.fillStyle = "#08060b"; ctx.globalAlpha = 0.92;
        parts.forEach((p, i) => {
          if (dt) { p.x += p.dir * p.v * dt; if (p.x > W + 40 || p.x < m.x0 - 40) parts[i] = p = spawn(false); }
          drawBat(ctx, p.x, m.y0 + m.h * p.fy + Math.sin(t * 0.9 + p.phase) * p.amp, p.s, p.dir, Math.sin(t * p.flap + p.phase));
        });
        if (dt) {
          if (!swoop && (wait -= dt) <= 0) {
            const dir = Math.random() < 0.5 ? 1 : -1;
            swoop = { dir, x: dir > 0 ? -40 : W + 40, y: H * rand(0.14, 0.32), dy: rand(-0.25, 0.35), v: rand(4, 5.5) * Math.max(0.6, W / 1440), s: rand(12, 16) * Math.max(0.7, Math.min(1, W / 1200)) };
          } else if (swoop) {
            swoop.x += swoop.dir * swoop.v * dt; swoop.y += swoop.dy * dt;
            if (swoop.x < -60 || swoop.x > W + 60) { swoop = null; wait = rand(9, 16) * 60; }
          }
        }
        if (swoop) drawBat(ctx, swoop.x, swoop.y + Math.sin(t * 3) * 10, swoop.s, swoop.dir, Math.sin(t * 17));
        ctx.globalAlpha = 1;
      },
    };
  };

  /* a spider that lowers itself from the cobweb, hangs a while, then climbs back up */
  const spider = () => {
    let L = 0, state = "rest", timer = 0, target = 0;
    return {
      layer: 0,
      init() { L = 0; state = "rest"; timer = rand(1.5, 3) * 60; },
      tick(ctx, t, dt) {
        const [fx, fy, drop] = spot().web, a = at(fx, fy), u = unit();
        if (dt) {
          timer -= dt;
          if (state === "rest" && timer <= 0) { state = "down"; target = drop * u * rand(0.55, 1); }
          else if (state === "down") { L += (0.25 + (target - L) * 0.01) * dt; if (L >= target) { L = target; state = "hang"; timer = rand(4, 7) * 60; } }
          else if (state === "hang" && timer <= 0) state = "up";
          else if (state === "up") { L -= 0.55 * dt; if (L <= 0) { L = 0; state = "rest"; timer = rand(5, 10) * 60; } }
        }
        if (L < 2) return;
        const sway = Math.sin(t * 1.1) * L * 0.035 + Math.sin(t * 2.3) * 1.2;
        const x = a.x + sway, y = a.y + L, s = Math.max(3.4, u * 0.0034);
        ctx.strokeStyle = "rgba(225,230,245,0.4)"; ctx.lineWidth = 0.7;
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.quadraticCurveTo(a.x + sway * 0.4, a.y + L * 0.5, x, y); ctx.stroke();
        const moving = state === "down" || state === "up";
        const wig = moving ? Math.sin(t * 16) * 0.16 : Math.sin(t * 1.4) * 0.05;
        ctx.save(); ctx.translate(x, y); ctx.rotate(-sway * 0.004);
        ctx.strokeStyle = ctx.fillStyle = "#0a0a0c"; ctx.lineWidth = Math.max(0.8, s * 0.15); ctx.lineJoin = ctx.lineCap = "round";
        [-1, 1].forEach((k) => [-0.95, -0.35, 0.2, 0.75].forEach((th, i) => {   // four legs a side, front pair reaching up
          const w = th + (i % 2 ? wig : -wig) * k;
          ctx.beginPath(); ctx.moveTo(0, s * 0.5);
          ctx.lineTo(k * Math.cos(w - 0.55) * s * 1.35, s * 0.5 + Math.sin(w - 0.55) * s * 1.35);
          ctx.lineTo(k * Math.cos(w + 0.35) * s * 2.5, s * 0.5 + Math.sin(w + 0.35) * s * 2.5);
          ctx.stroke();
        }));
        ctx.beginPath(); ctx.ellipse(0, s * 0.5, s * 0.55, s * 0.6, 0, 0, TAU); ctx.fill();
        ctx.beginPath(); ctx.ellipse(0, s * 1.75, s * 0.85, s * 1.05, 0, 0, TAU); ctx.fill();
        ctx.strokeStyle = "rgba(190,200,235,0.45)"; ctx.lineWidth = 0.7;                // moonlight on its back
        ctx.beginPath(); ctx.ellipse(0, s * 1.75, s * 0.85, s * 1.05, 0, -1.9, -0.5); ctx.stroke();
        ctx.restore();
      },
    };
  };

  /* a pair of eyes opens in the dark woods, blinks, and fades away */
  const eyes = () => {
    let cur = null, wait = 0, last = -1;
    return {
      layer: 0,
      init() { cur = null; wait = rand(2.5, 4) * 60; },
      tick(ctx, t, dt) {
        if (dt) {
          if (!cur && (wait -= dt) <= 0) {
            const list = spot().eyes;
            let i = Math.floor(Math.random() * list.length); if (i === last && list.length > 1) i = (i + 1) % list.length; last = i;
            cur = { at: list[i], age: 0, life: rand(4.5, 7) * 60, blinks: [rand(0.3, 0.42), rand(0.62, 0.78)] };
          } else if (cur && (cur.age += dt) > cur.life) { cur = null; wait = rand(4, 8) * 60; }
        }
        if (!cur) return;
        const k = cur.age / cur.life, fade = Math.min(1, k * 5, (1 - k) * 5);
        let open = 1;
        cur.blinks.forEach((b) => { const d = (Math.abs(k - b) * cur.life) / 60; if (d < 0.13) open = Math.min(open, d / 0.13); });
        const { x, y } = at(cur.at[0], cur.at[1]), s = Math.max(1.5, unit() * 0.0015), gap = s * 3.6;
        ctx.globalCompositeOperation = "lighter";
        [-1, 1].forEach((side) => {
          const ex = x + side * gap / 2;
          glow(ctx, ex, y, s * 6, [[0, `rgba(255,170,50,${0.45 * fade})`], [1, "rgba(255,140,30,0)"]]);
          ctx.fillStyle = `rgba(255,222,130,${0.95 * fade})`;
          ctx.beginPath(); ctx.ellipse(ex, y, s * 1.15, s * 0.7 * Math.max(0.06, open), side * 0.28, 0, TAU); ctx.fill();
        });
        ctx.globalCompositeOperation = "source-over";
      },
    };
  };

  /* low mist drifting through the graveyard, behind the bottles */
  const fog = (count) => {
    let parts = [];
    return {
      layer: 0,
      init() { parts = Array.from({ length: count }, () => ({ u: rand(-0.1, 1.1), v: rand(0.006, 0.014) * (Math.random() < 0.5 ? 1 : -1), fy: rand(0, 1), r: rand(0.07, 0.14), a: rand(0.06, 0.11) })); },
      tick(ctx, t, dt) {
        const [x0, x1, y0, y1] = spot().mist, u = unit();
        parts.forEach((p) => {
          if (dt) { p.u += (p.v * dt) / 60; if (p.u > 1.15) p.u = -0.15; if (p.u < -0.15) p.u = 1.15; }
          const { x, y } = at(x0 + (x1 - x0) * p.u, y0 + (y1 - y0) * p.fy), r = p.r * u;
          ctx.save(); ctx.translate(x, y); ctx.scale(1, 0.28);
          glow(ctx, 0, 0, r, [[0, `rgba(175,180,205,${p.a})`], [1, "rgba(175,180,205,0)"]]);
          ctx.restore();
        });
      },
    };
  };

  /* Summer: Fourth of July fireworks over the sea, with reflections */
  const fireworks = () => {
    const PALETTES = [["#ff5d5d", "#ffd0d0"], ["#ffffff", "#fff1d6"], ["#7fb2ff", "#d7e7ff"], ["#ffd27a", "#fff0c2"]];
    let rockets = [], sparks = [], glows = [], next = 0;
    const burst = (x, y, pal, scale) => {
      const n = Math.round(rand(70, 110));
      const sp = rand(1.5, 2.4) * scale;
      for (let i = 0; i < n; i++) {                                // a filled sphere of sparks, not a ring
        const a = rand(0, Math.PI * 2), v = sp * Math.sqrt(rand(0.08, 1));
        sparks.push({ x, y, px: x, py: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: 1, decay: rand(0.007, 0.014), c: Math.random() < 0.25 ? pal[1] : pal[0] });
      }
      glows.push({ x, y, life: 1, c: pal[0], r: 120 * scale });
    };
    const launch = (still) => {
      const hz = horizon(), wide = W > 900;
      const x = wide ? rand(W * 0.3, W * 0.96) : rand(W * 0.08, W * 0.92);
      const top = wide ? rand(0.05, 0.3) * H : photoH() * rand(0.04, 0.24);
      const r = { x, y: hz, ty: top, v: (hz - top) / 70, pal: pick(PALETTES), scale: Math.max(0.6, Math.min(1.2, W / 1440 + 0.25)) };
      if (still) burst(x, top, r.pal, r.scale); else rockets.push(r);
    };
    return {
      layer: 0,
      init() { rockets = []; sparks = []; glows = []; next = 40; this.still(2); },        // open on bursts already in the sky
      still(n = 3) { for (let i = 0; i < n; i++) launch(true); sparks.forEach((s) => { s.x += s.vx * 22; s.y += s.vy * 22 + 2; s.px = s.x - s.vx * 3; s.py = s.y - s.vy * 3; s.life = 0.75; }); },
      tick(ctx, t, dt) {
        if (dt) {
          next -= dt;
          if (next <= 0) { launch(false); next = rand(55, 120); }
          rockets = rockets.filter((r) => { r.y -= r.v * dt * (0.35 + 0.65 * (r.y - r.ty) / (horizon() - r.ty + 1)); if (r.y <= r.ty + 2) { burst(r.x, r.y, r.pal, r.scale); return false; } return true; });
          sparks.forEach((s) => { s.px = s.x; s.py = s.y; s.vx *= Math.pow(0.985, dt); s.vy = s.vy * Math.pow(0.985, dt) + 0.022 * dt; s.x += s.vx * dt; s.y += s.vy * dt; s.life -= s.decay * dt; });
          sparks = sparks.filter((s) => s.life > 0);
          glows.forEach((g) => { g.life -= 0.03 * dt; });
          glows = glows.filter((g) => g.life > 0);
        }
        const hz = horizon();
        ctx.globalCompositeOperation = "lighter";
        glows.forEach((g) => {
          const a = g.life * 0.22;
          const grd = ctx.createRadialGradient(g.x, g.y, 0, g.x, g.y, g.r);
          grd.addColorStop(0, `rgba(255,240,220,${a})`); grd.addColorStop(1, "rgba(255,240,220,0)");
          ctx.fillStyle = grd; ctx.beginPath(); ctx.arc(g.x, g.y, g.r, 0, Math.PI * 2); ctx.fill();
        });
        rockets.forEach((r) => {
          ctx.globalAlpha = 0.9; ctx.strokeStyle = "#ffe9c4"; ctx.lineWidth = 1.6;
          ctx.beginPath(); ctx.moveTo(r.x, r.y); ctx.lineTo(r.x + rand(-0.5, 0.5), r.y + 16); ctx.stroke();
        });
        ctx.lineCap = "round";
        sparks.forEach((s) => {                                    // a soft halo, then a bright core
          const a = Math.pow(s.life, 1.4);
          ctx.strokeStyle = s.c;
          ctx.globalAlpha = a * 0.22; ctx.lineWidth = 5;
          ctx.beginPath(); ctx.moveTo(s.px - s.vx * 2, s.py - s.vy * 2); ctx.lineTo(s.x, s.y); ctx.stroke();
          ctx.globalAlpha = a; ctx.lineWidth = 1.4;
          ctx.beginPath(); ctx.moveTo(s.px - s.vx * 2.5, s.py - s.vy * 2.5); ctx.lineTo(s.x, s.y); ctx.stroke();
        });
        ctx.globalAlpha = 1; ctx.globalCompositeOperation = "source-over";
      },
    };
  };

  const SYSTEMS = {
    spring: () => [drift(0, 18, "petal", ["#efb8bc", "#f4c9cb", "#e9a7ad", "#f8dcdc"]), drift(1, 3, "petal", ["#efb8bc", "#e9a7ad"])],
    summer: () => [fireworks()],
    fall: () => [moon(3), fog(7), flames(), eyes(), spider(), drift(0, 9, "leaf", ["#b4532a", "#8c3b1b", "#c97a30", "#6f2f16"]), bats(5)],
    winter: () => [drift(0, 90, "snow", ["#fff"]), drift(1, 6, "snow", ["#fff"])],
    blackfriday: () => [drift(0, 44, "dust", ["#f0c882"]), drift(1, 4, "dust", ["#f0c882"])],
  };
  const systems = (SYSTEMS[season] || (() => []))();

  const size = () => {
    const r = hero.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
    W = r.width; H = r.height;
    canvases.forEach((c, i) => { c.width = Math.round(W * dpr); c.height = Math.round(H * dpr); ctxs[i].setTransform(dpr, 0, 0, dpr, 0, 0); });
  };
  const render = (t, dt) => {
    const tf = W > 900 && photo ? getComputedStyle(photo).transform : "none";
    zoom = tf && tf !== "none" ? new DOMMatrixReadOnly(tf).a : 1;
    ctxs.forEach((ctx) => ctx.clearRect(0, 0, W, H));
    systems.forEach((s) => s.tick(ctxs[s.layer], t, dt));
  };
  const resize = () => {
    size();
    systems.forEach((s) => s.init());
    render(3, 0);
  };
  resize();
  let rt;
  window.addEventListener("resize", () => { clearTimeout(rt); rt = setTimeout(resize, 200); });
  if (reduce) return;                                   // one still frame for reduced motion

  let visible = true, last = performance.now(), raf;
  const loop = (now) => {
    const dt = Math.min(3, (now - last) / 16.67); last = now;
    render(now / 1000, dt);
    raf = requestAnimationFrame(loop);
  };
  const run = (on) => {
    cancelAnimationFrame(raf);
    if (on && !document.hidden) { last = performance.now(); raf = requestAnimationFrame(loop); }
  };
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; run(visible); }).observe(hero);
  }
  document.addEventListener("visibilitychange", () => run(visible));
  run(true);
})();
